import { useEffect } from 'react';

const SCRIPT_ID = 'did-agent-script';

const removeWidget = () => {
  document.getElementById(SCRIPT_ID)?.remove();
  document.querySelectorAll('did-agent, [id^="did-"], [class*="didagent"], [data-name="did-agent"]').forEach((el) => el.remove());
};

export const DidTutorWidget = ({ open }) => {
  useEffect(() => {
    if (!open || document.getElementById(SCRIPT_ID)) return;
    const s = document.createElement('script');
    s.id = SCRIPT_ID;
    s.type = 'module';
    s.src = 'https://agent.d-id.com/v2/index.js';
    s.setAttribute('data-mode', 'fabio');
    s.setAttribute('data-client-key', process.env.REACT_APP_DID_CLIENT_KEY);
    s.setAttribute('data-agent-id', 'v2_agt_-UxS6eNn');
    s.setAttribute('data-name', 'did-agent');
    s.setAttribute('data-monitor', 'true');
    s.setAttribute('data-light-mode', 'true');
    s.setAttribute('data-orientation', 'horizontal');
    s.setAttribute('data-position', 'right');
    s.setAttribute('data-open-mode', 'expanded');
    document.body.appendChild(s);
  }, [open]);

  useEffect(() => removeWidget, []);

  return null;
};
